module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "icon",
    class: _vm.type,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": _vm.width,
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "p-id": "2427"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.svg[_vm.type],
      "fill": _vm.color
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-25aa2007!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/svg/svg.vue
// module id = 459
// module chunks = 27